import { EventPanelFormType, EventPanelMetadata } from '@mark43/cad-api';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useAgencyTypeGlobalAttributeId() {
    const { agencyTypeGlobalAttrId: eventAgencyTypeGlobalAttrId } =
        useEventMetadataStore()?.state?.metadata ?? ({} as EventPanelMetadata);
    const unitAssignment = useUnitAssignment();
    const { control } = useFormContext<EventPanelFormType>();
    const callForService = useWatch({ control, name: 'callForService' });

    return (
        eventAgencyTypeGlobalAttrId ||
        callForService?.agencyTypeGlobalAttrIds?.[0] ||
        unitAssignment?.unitAgencyTypeGlobalAttrId
    );
}
